module.exports = global["Bloodhound"] = require("-!/usr/lib/node_modules/source-map-loader/index.js!./typeahead.bundle.js");